import { Component, OnInit, Inject, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { RetestService } from 'app/services/retest-service';
import { Retest } from 'app/models/retest/retest';
import { HouseholdService } from 'app/services/household-service';
import { VoucherService } from 'app/services/voucher-service';
import { Voucher } from 'app/models/vouchers/voucher';
import { IHousehold } from 'app/models/household/household';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { SampleViewModel } from 'app/models/well/samples/sample.viewmodel';
import { EditSampleComponent } from '../well/samples/edit/edit-samples.component';
import { AuthService } from '@shared/auth/auth.service';

/*
 * Add Retest Dialog
 */
@Component({
  selector: 'dialog-retests-add',
  templateUrl: 'retests-add-dialog.html',
  styleUrls: ['./retests-add-dialog.scss']
})
export class DialogAddRetestsComponent implements OnInit {
  @Input('voucherId')
  voucherId: number = 0;
  @Input('householdId')
  householdId: number = 0;
  loading: boolean = false;
  processing: boolean = false;
  retestForm = new FormGroup({
    completedDate: new FormControl(new Date()),
    dueBy: new FormControl(new Date()),
    retestYear: new FormControl(0),
    retestQuarter: new FormControl(0),
    tier: new FormControl(0),
    comments: new FormControl(''),
  });
  voucher: Voucher = undefined;
  household: IHousehold = undefined;
  retestType: string = 'Voucher';
  identifier: string = '';
  highestNitrateSample: SampleViewModel = undefined;
  nitrateResult: string = '';
  currentYr = new Date().getFullYear();
  recommendYear: number = 0;
  recommendQuarter: number = 0;
  recommendTier: number = 0;


  retest: Retest = {
    id: 0,
    reviewDate: '',
    voucherId: 0,
    voucherLetterId: 0,
    householdId: 0,
    householdLetterId: 0,
    orgininalSampleId: 0,
    retestSampleId: 0,
    retestType: this.retestService.retestLubgwmaWellRetestType,
    createDate: '',
    createdBy: '',
    modifiyDate: '',
    mdifiedby: '',
    comments: '',
    retestQuarter: 0,
    retestYear: 0,
    dueBy: '',
    isComplete: false,
    completedDate: '',
    tier: 0,
    voucherIdentifier: '',
    highestNitrateSampleId: 0,
    highestNitrateTier: 0,
    highestNitrateValue: '',
    voucherStatus : '',
    incomplete: false,
    incompleteReason: ''
  }

  constructor(public retestService: RetestService, private toastr: ToastrService,
    public voucherService: VoucherService, public householdService: HouseholdService,
    public oregonwellDataService: OregonWellDataService, public dialog: MatDialog, public authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: number, private dialogRef: MatDialogRef<DialogAddRetestsComponent>) {
    this.voucherId = this.data;
  }

  ngOnInit(): void {
    this.processing = true;

    this.load();
  }

  load() {
    this.processing = true;
    if(this.voucherId > 0){ 
      this.voucherService.getVoucherById(this.voucherId).subscribe(
        result => {
          this.voucher = result;
          this.retest.voucherId = this.voucher.id;
          this.identifier = this.voucher.voucherId;
          //get the most recent sample by voucher id
          this.oregonwellDataService.GetHigestNitrateSampleByVoucherId(this.voucher.id).subscribe(
            result => {
              this.highestNitrateSample = result;
              if(this.highestNitrateSample != undefined && this.highestNitrateSample != null && this.highestNitrateSample.sampleId > 0){
                this.retest.orgininalSampleId = this.highestNitrateSample.sampleId;
                this.nitrateResult = this.getNitrateResult();
                this.setFormValues();
              }
              this.processing = false;
            },
            error => {
              this.processing = false;
            }
          );
        },
        error => {
          this.processing = false;
        }
      );
    }
    else if(this.householdId > 0){
      
      this.householdService.getHouseholdById(this.householdId).subscribe(
        result => {
          this.household = result;
          this.retest.householdId = this.household.id;
          this.identifier = this.household.id.toString();
          this.retestType = 'Household';
          this.processing = false;
        },
        error => {
          this.processing = false;
        }
      );
    }
  }

  getNitrateResult(): string {
    if(this.highestNitrateSample != undefined && this.highestNitrateSample != null && this.highestNitrateSample.parameterResults != null && 
      this.highestNitrateSample.parameterResults.length > 0) {
      var result = this.highestNitrateSample.parameterResults[0];

      if(result != null)
      {
        return result.parameterResult;
      };
      return 'None Available';
    }
    return 'None Available';
  }

  getFormValues() {
      this.retest.retestYear = this.retestForm.value.retestYear;
      this.retest.retestQuarter = this.retestForm.value.retestQuarter; 
      this.retest.tier = this.retestForm.value.tier; 
      this.retest.comments = this.retestForm.value.comments; 
      if (this.retestForm.value.dueBy == null
        || this.retestForm.value.dueBy.toString() == "Invalid Date"
        || this.retestForm.value.dueBy.toString() == '') {
  
        this.retestForm.controls['dueBy'].setValue(null);
        this.retest.dueBy = null;  
      }
      else {
        this.retest.dueBy = new Date(this.retestForm.value.dueBy);
      }
  }

  setFormValues() {
    let yr = new Date().getFullYear();
    this.retest.retestYear = yr + 1;
    this.retest.tier = 1;
    this.retest.retestQuarter = Math.floor((new Date().getMonth() + 3) / 3);
    if(this.highestNitrateSample != undefined && this.highestNitrateSample != null && this.highestNitrateSample.createDate != null) {
      yr = new Date(this.highestNitrateSample.createDate).getFullYear();
      this.retest.retestQuarter = Math.floor((new Date(this.highestNitrateSample.createDate).getMonth() + 3) / 3);
    }

    if(this.nitrateResult == undefined || this.nitrateResult == null || this.nitrateResult == ''){
      this.retest.tier = 1;
      this.retestForm.get("dueBy").setValue(new Date());
    }
    else {
      try{
        let dt = new Date(this.highestNitrateSample.createDate);

        var y: number = +this.nitrateResult.trim();
        if(y <=5){
          this.retest.tier = 1;
          this.retest.retestYear = yr + 1;
          dt.setFullYear(this.retest.retestYear);
          this.retestForm.get("dueBy").setValue(dt);
        }
        else if(y >5 && y < 10){
          this.retest.tier = 2;
          this.retest.retestYear = yr;
          if(this.retest.retestQuarter == 4)
          {
            this.retest.retestYear = yr + 1;
            this.retest.retestQuarter = 1;
          }
          dt.setDate(dt.getDate() + 91 );
          this.retestForm.get("dueBy").setValue(dt);
        }
        else if(y >= 10 && y <= 25){
          this.retest.tier = 3;
          this.retest.retestYear = yr + 1;
          dt.setFullYear(this.retest.retestYear);
          this.retestForm.get("dueBy").setValue(dt);
        }
        else if(y > 25){
          this.retest.tier = 4;
          this.retest.retestYear = yr + 1;
          dt.setFullYear(this.retest.retestYear);
          this.retestForm.get("dueBy").setValue(dt);
        }
      }
      catch(e){
        this.retest.tier = 1;
        this.retest.retestYear = yr + 1;
      }
    }

    
    this.recommendYear = this.retest.retestYear;
    this.recommendQuarter = this.retest.retestQuarter;
    this.recommendTier = this.retest.tier;
    this.retestForm.get("retestQuarter").setValue(this.recommendQuarter );
    this.retestForm.get("retestYear").setValue(this.recommendYear );
    this.retestForm.get("tier").setValue(this.recommendTier );

  }

  editSample(id: number){
    const dialogRef = this.dialog.open(EditSampleComponent, {
      width: '90%',
      data: id
    });
    dialogRef.afterClosed().subscribe(result => {
        this.load();
    });
  }

  onSubmit() {
    this.processing = true;
    this.getFormValues();
    console.log(JSON.stringify(this.retest));

    this.retestService.addRetest(this.retest).subscribe(
      result => {
        this.toastr.success("Retest Added");
        this.processing = false;
      },
      error => {
        this.processing = false;
        this.toastr.error("Unable to Add Retest " + error.message);
      },
      () => {
        this.dialogRef.close();
      }
    );
  }

 
}